import axios from "axios";
import React, { createContext, useContext, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import App from "./App";
import LoginPage from "./LoginPage";
import { WRAPInitializer } from "./misc/WRAPInitializer";
import Authorization from "./Authorization";
import { makeStyles } from "@material-ui/core/styles";
import LoadingProgress from "./parts/LoadingProgress";
import _crypto  from "crypto-js";
import { isEmpty } from "./utils/FPEUtils";

function FPERouter() {
  const pathname = window.location.pathname;
  const loginPath = `${pathname}#login`;
  return (
    <ProvideAuth>
      <Router>
        <Switch>
          <Route exact path={loginPath}><LoginPage /></Route>
          <PrivateRoute exact path={pathname}>
            <React.Suspense fallback={<Loading/>}>
              <Authorization>
                <WRAPInitializer/>
                <App/>
              </Authorization>
            </React.Suspense>
          </PrivateRoute>
        </Switch>
      </Router>
    </ProvideAuth>
  );
}

export default FPERouter;

function PrivateRoute({ children, ...rest }) {
  const auth = useContext(authContext);
  const authKey = Object.freeze(auth.user ? _crypto.AES.decrypt(auth.user, process.env.REACT_APP_CRYPTO_KEY) : {});
  const pathname = window.location.pathname;
  const loginPath = `${pathname}#login`;
  return (
    <Route
      {...rest}
      render={({ location }) =>
        verification(authKey) ? (
          children
        ) : (
          <Redirect
            to={{
            pathname: loginPath,
            state: { from: location }
            }}
          />
        )
      }
    />
  );
}

const verification = authKey => {
  if (isEmpty(authKey)) {
    return false;
  }
  try {
    return !!authKey.toString(_crypto.enc.Utf8).length;
  } catch (e) {
    return false
  }
};

const cgiAuth = {
  async signIn(values, cb) {
    const params = new URLSearchParams();
    params.append('id', values.id);
    params.append('password', values.password);
    await axios.post("./cgi/login.cgi", params).then(res => {
      if (res.data) {
        const token = _crypto.AES.encrypt(JSON.stringify(res.data), process.env.REACT_APP_CRYPTO_KEY).toString();
        sessionStorage.setItem('token', token);
        cb(token);
        return;
      }
      cb(false);
    }).catch((e) => {
      if (e.response.status === 401) {
        cb(false);
        return;
      }
      throw e;
    });

  },
  signOut(cb) {
    sessionStorage.removeItem('token');
    cb();
  }
};

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */
export const authContext = createContext();

function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return (
    <authContext.Provider value={auth}>
      {children}
    </authContext.Provider>
  );
}

function useProvideAuth() {
  const [user, setUser] = useState(sessionStorage.getItem('token'));

  const signIn = (values, cb) => {
    return cgiAuth.signIn(values, (ret) => {
      setUser(ret);
      cb(ret);
    });
  };

  const signOut = () => {
    return cgiAuth.signOut(() => {
      // setUser(null);
    });
  };

  return {
    user,
    signIn,
    signOut
  };
}

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateY(-50%) translateX(-50%)'
  }
}));
function Loading() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <LoadingProgress/>
    </div>
  )
}
